import { Permission } from "@edgetier/watchtower-types";
import Page from "constants/page";
import { getDefaultRouteUrls } from "utilities/get-default-route-urls";

const defaultRouteUrls = getDefaultRouteUrls();

export const PERMISSION_PAGE_MAPPING = new Map<Permission, string | Page>();

PERMISSION_PAGE_MAPPING.set(Permission.ViewExplore, defaultRouteUrls[Page.Explore].url);
PERMISSION_PAGE_MAPPING.set(Permission.ViewAnomalies, Page.Anomalies);
PERMISSION_PAGE_MAPPING.set(Permission.ViewAgent, defaultRouteUrls[Page.Agents].url);
PERMISSION_PAGE_MAPPING.set(Permission.ViewLive, defaultRouteUrls[Page.Live].url);
PERMISSION_PAGE_MAPPING.set(Permission.ManageUsers, Page.Users);
